// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"#E56C25","d":"M5 2a1 1 0 00-1 1v18c0 .25.1.52.29.7.19.2.43.3.67.3h14.08c.24 0 .5-.1.67-.3A1 1 0 0020 21V7.5L14.5 2H5z"}},{"tag":"path","attrs":{"fill":"#fff","d":"M11.95 12.71c.33 0 .61-.04.84-.13.22-.1.4-.21.55-.36.13-.15.23-.3.3-.48a1.7 1.7 0 00-.02-1.13 1.17 1.17 0 00-.31-.48 1.43 1.43 0 00-.55-.33c-.23-.08-.5-.12-.83-.12h-1.68v3.03h1.7zM9.5 16.5V9h2.61c.37 0 .7.06.99.17a2.18 2.18 0 011.23 1.16c.11.27.17.55.17.85a2.12 2.12 0 01-.69 1.6 2.43 2.43 0 01-1.66.62h-1.9v3.1H9.5z"}},{"tag":"path","attrs":{"fill":"#FFE6CC","d":"M20 7.5h-4.5a1 1 0 01-1-1V2L20 7.5z","opacity":0.5}}]};

export default defineComponent({
  name: 'IconPptFilledLight',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__ppt_filled_light`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
